import StarknetWalletConnector from '../starknetWalletConnector.js';

class Bitget extends StarknetWalletConnector {
    constructor(opts) {
        super('Bitget Starknet', 'bitkeep', opts);
        this.overrideKey = 'bitgetstarknet';
    }
    // adding this method due to inconsistencies in isConnected flag on the window object
    // the window object shows isConnected=true and no provider/account defined
    isProviderConnected() {
        var _a;
        const wallet = this.getWallet();
        return (_a = (Boolean(wallet === null || wallet === void 0 ? void 0 : wallet.account) && (wallet === null || wallet === void 0 ? void 0 : wallet.isConnected))) !== null && _a !== void 0 ? _a : false;
    }
}

export { Bitget };
